export interface ChangelogEntry {
  title: string
  body: string
  date: string
}

/**
 * Small, plain notes about what changed in the portal. Written for members,
 * not for a release audience — no version numbers, no feature marketing.
 */
export const CHANGELOG: ChangelogEntry[] = [
  {
    title: 'Recordings can be read as well as heard',
    body: 'Every recording in the archive now has a transcript, so you can read it without playing anything.',
    date: '18 August',
  },
  {
    title: 'You can name voices, not just faces',
    body: 'If you recognise someone speaking on an old tape, you can now say so.',
    date: '11 August',
  },
  {
    title: 'Memorial pages',
    body: 'When a member dies, their page stays and becomes a place to leave something you remember.',
    date: '2 August',
  },
]
